export const title = "Please confirm your address";
export const findAddress = {
  text: "Can't find the right address option?",
  action: " Proceed and confirm later",
};
